import type { SandboxErrorHandler } from './SandboxErrorBoundary';

/**
 * Global error handler for sandbox errors. Set this once at app initialization
 * to route sandbox errors to your error reporting service (e.g. Sentry).
 *
 * Usage in app entry point:
 * ```ts
 * import * as Sentry from '@sentry/react';
 * import { setSandboxErrorHandler } from '@trinity/chat-components/components/Sandbox';
 *
 * setSandboxErrorHandler((error, context) => {
 *   Sentry.captureException(error, {
 *     tags: { sandbox_error_source: context.source },
 *     extra: { message: context.message },
 *   });
 * });
 * ```
 */
let globalHandler: SandboxErrorHandler | null = null;

export function setSandboxErrorHandler(handler: SandboxErrorHandler): void {
  globalHandler = handler;
}

export function getSandboxErrorHandler(): SandboxErrorHandler | null {
  return globalHandler;
}
